// ./SignUpPage.jsx
import { Box } from "@mui/material";
import AuthShell from "./components/AuthShell.jsx";
import AuthBrandPanel from "./components/AuthBrandPanel.jsx";
import AuthFormHeader from "./components/AuthFormHeader.jsx";
import {
  AUTH_BRAND_CONTENT,
  AUTH_FORM_HEADERS,
} from "./components/authContents";
import SignUpTabs from "./sections/SignUpTabs.jsx";

export default function SignUpPage() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flex: 1,
        minHeight: 0,
        bgcolor: "#EEF1F0",
      }}
    >
      <AuthShell
        maxFormWidth={480}
        brand={<AuthBrandPanel {...AUTH_BRAND_CONTENT.signUp} />}
      >
        <AuthFormHeader {...AUTH_FORM_HEADERS.signUp} logoMb={3} mb={3} />

        <SignUpTabs />
      </AuthShell>
    </Box>
  );
}
